import type {StudioResponse} from '../../../data/repositories/StudioRepository';
import {ApiError, GENERIC_ERROR} from '../errors';

/**
 * A Studio response's data. A failure throws the response's ApiError, whose message is written
 * for authors, so a store can show it as it is.
 */
export function unwrap<T>(response: StudioResponse<T>): T {
  if (!response.success)
    throw response.error || new ApiError(GENERIC_ERROR, response.status || 0);
  return response.data as T;
}

/**
 * Sends one request through a store's StudioRepository and resolves to its data (see
 * `unwrap`), e.g. `studioRequest(org, o => this.repository.getJob(o, id))`. Studio is only
 * routed inside an organization, so without one it fails as the platform's would, unsent.
 */
export async function studioRequest<T>(
  organizationId: string | undefined,
  send: (organizationId: string) => Promise<StudioResponse<T>>,
): Promise<T> {
  if (!organizationId) throw new ApiError(GENERIC_ERROR, 0);
  return unwrap(await send(organizationId));
}
